(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.naninhaClickSwallowInitialized) return;
    window.naninhaClickSwallowInitialized = true;
    let navigating = false;
    let activeBird = null;
    const swallow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="140 140 300 330" aria-hidden="true"><path d="M150 237 C183 243 218 234 261 234 C306 231 335 245 351 274 C362 252 372 232 391 232 C403 232 411 240 416 243 L429 238 L416 249 C410 285 400 312 375 333 C345 360 310 373 281 392 C250 415 215 442 185 455 C224 425 256 393 280 366 C302 341 319 322 327 307 C300 333 277 325 254 305 C228 282 180 280 150 237 Z"/><path d="M225 149 C253 176 297 185 327 208 C348 225 353 247 352 269 C329 242 305 235 270 233 C245 211 223 181 225 149 Z"/></svg>';
    document.addEventListener('click', (event) => {
      if (!event.isTrusted) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      const destination = link ? new URL(link.href, window.location.href) : null;
      const shouldNavigate = Boolean(link && destination && !event.defaultPrevented &&
        !link.hasAttribute('download') && (!link.target || link.target === '_self') &&
        destination.origin === window.location.origin && !destination.hash &&
        destination.href !== window.location.href);
      if (shouldNavigate) event.preventDefault();
      if (navigating) return;
      if (shouldNavigate) navigating = true;
      if (activeBird) activeBird.remove();
      const bird = document.createElement('span');
      bird.className = 'naninha-click-swallow';
      bird.setAttribute('aria-hidden', 'true');
      bird.innerHTML = swallow;
      const bounds = (link || (event.target instanceof Element ? event.target : document.body)).getBoundingClientRect();
      const keyboard = event.detail === 0;
      const x = keyboard ? bounds.left + bounds.width / 2 : event.clientX;
      const y = keyboard ? bounds.top + Math.min(bounds.height / 2, 40) : event.clientY;
      bird.style.left = Math.max(18, Math.min(window.innerWidth - 50, x)) + 'px';
      bird.style.top = Math.max(20, Math.min(window.innerHeight - 50, y)) + 'px';
      document.body.appendChild(bird);
      activeBird = bird;
      let completed = false;
      const proceed = () => {
        if (completed) return;
        completed = true;
        bird.remove();
        if (activeBird === bird) activeBird = null;
        if (shouldNavigate) window.location.assign(destination.href);
      };
      try {
        const flight = bird.animate([
          { transform: 'translate(-50%, -50%) rotate(-8deg) scale(.8)', opacity: 0 },
          { transform: 'translate(0px, -18px) rotate(5deg) scale(1)', opacity: 1, offset: .18 },
          { transform: 'translate(20px, -40px) rotate(-7deg) scale(1.04)', opacity: 1, offset: .42 },
          { transform: 'translate(42px, -62px) rotate(4deg) scale(1)', opacity: 1, offset: .68 },
          { transform: 'translate(75px, -105px) rotate(-5deg) scale(.8)', opacity: 0 }
        ], { duration: 1000, easing: 'ease-in-out', fill: 'forwards' });
        flight.finished.then(proceed, proceed);
      } catch (_) { proceed(); }
      window.setTimeout(proceed, 1100);
    });
    window.addEventListener('pageshow', () => { navigating = false; });
  })();
  } catch(e) { console.error(e); }
})();

})();
